import { executiveSummary } from "@/data/roadmap";
import { ROADMAP } from "@/constants/testIds/roadmap";
import { AlertTriangle, Target } from "lucide-react";

export default function ExecSummary() {
  return (
    <section
      id="summary"
      data-testid={ROADMAP.execSummary}
      className="py-20 lg:py-28 border-b border-[#DEE2E6] bg-[#F8F9FA]"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <SectionLabel n="01" label="Executive Summary" />
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl tracking-tighter font-bold mt-3 max-w-4xl">
          From paper, fragmentation & guesswork — to one unified system that runs itself.
        </h2>
        <p className="mt-6 max-w-3xl text-lg text-[#495057] leading-relaxed">
          <strong className="text-[#0A0A0A]">Reference case:</strong>{" "}
          {executiveSummary.clientCase}
        </p>

        <div className="grid lg:grid-cols-2 gap-0 mt-14 border border-[#0A0A0A]">
          <div className="p-8 lg:p-10 border-b lg:border-b-0 lg:border-r border-[#0A0A0A] bg-white">
            <div className="flex items-center gap-2 text-[#D90429] mb-5">
              <AlertTriangle size={18} />
              <span className="text-xs uppercase tracking-[0.2em] font-semibold">
                Today&apos;s pain
              </span>
            </div>
            <ul className="space-y-4">
              {executiveSummary.problem.map((p, i) => (
                <li key={p.title} className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="font-mono text-xs text-[#495057] mt-1 tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <div className="font-medium text-[#0A0A0A]">{p.title}</div>
                    <div className="text-sm text-[#495057] mt-0.5">{p.detail}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="p-8 lg:p-10 bg-[#0A0A0A] text-white">
            <div className="flex items-center gap-2 text-[#FF4F00] mb-5">
              <Target size={18} />
              <span className="text-xs uppercase tracking-[0.2em] font-semibold">
                Gr8Boost ERP delivers
              </span>
            </div>
            <ul className="space-y-5">
              {executiveSummary.outcomes.map((o, i) => (
                <li key={o} className="grid grid-cols-[auto_1fr] gap-3">
                  <span className="font-mono text-xs text-white/50 mt-1 tabular-nums">
                    →
                  </span>
                  <div className="text-lg leading-snug">{o}</div>
                </li>
              ))}
            </ul>
            <div className="mt-8 pt-6 border-t border-white/10 text-sm text-white/70 leading-relaxed">
              Gr8Boost ERP consolidates procurement, inventory, finance, HR, engineering, sales, customer
              service, IT & internal audit — into a single, real-time system with Gr8Agentic AI watching
              over every transaction.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionLabel({ n, label }) {
  return (
    <div className="flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#495057]">
      <span className="font-mono text-[#FF4F00]">/ {n}</span>
      <span className="font-semibold">{label}</span>
    </div>
  );
}
